module.exports = __webpack_public_path__ + "img/instalacion-tuberias (2).8cf55d70.jpg";